// ** React Imports
import { useEffect, useRef, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore, LeadActivityHistoryStore, ActivityHistoryDialogStore, LeadActivityCadenceStore, CadenceListDialogStore, LeadActivityOutcomeStore, ActivityOutcomes, TwilioStore, CallButton, IncomingCallPopupStore, InboundCallStore } from 'src/stores/LeadStore';
import { getActivityEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import DoActivityOutcomes from './DoActivityOutcomes';
import PhoneControls from './PhoneControls';
import { callHangup, hangupIncomingCall, intitializeDeviceAndStartCall } from 'src/features/Twilio/TwilioBase';
import CallEndIcon from '@mui/icons-material/CallEnd';

import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import StandardSkeleton from '../../common/StandardSkeleton';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivityInboundPhoneCall = () => {
    const outcomesRecord = LeadActivityOutcomeStore.useState(s => s.record);
    const [dataLoaded, setDataLoaded] = useState(false);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead);
    const [connection, setConnection] = useState<null | HubConnection>(null);
    const [showMessageStatus, setShowMessageStatus] = useState(false);
    const [sentStatus, setSentStatus] = useState('');
    const numberCalling = IncomingCallPopupStore.useState(s => s.numberCalling);
    const [showHangupButton, setShowHangupButton] = useState(true);
    const showPhoneControls = InboundCallStore.useState(s => s.showPhoneControls);
    const hasHungup = InboundCallStore.useState(s => s.hasHungup);

    useEffect(() => {
        const fetchOutcomes = async () => {
            const response = await client.get(leadEndpoints.getactivityoutcomes.replace('{leadid}', "" + selectedLead?.id.toString()));
            LeadActivityOutcomeStore.update(s => { s.record = response.data });
            setSentStatus("From: " + numberCalling);
            setShowMessageStatus(true);

            setDataLoaded(true)
        }
        if (selectedLead != null) fetchOutcomes();
    }, [])

    const hangupCall = () => {
        hangupIncomingCall();
        setShowHangupButton(false);
        setSentStatus("Call finished.");
        setShowMessageStatus(true);
    }

    if (dataLoaded) {
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box >
                                    <Grid container alignContent='left' spacing={2}>
                                        <Grid item xs={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                            <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                Incoming Phone Call
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={10} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            {showMessageStatus && showPhoneControls &&
                                                <Grid item xs={12} md={12} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                                    <Alert severity="info">
                                                        {sentStatus}
                                                    </Alert>
                                                </Grid>
                                            }    
                                        </Grid>
                                        <Grid item xs={12} md={2} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                                            {showHangupButton && showPhoneControls && !hasHungup &&
                                                <Tooltip title="Hangup Phone Call" >
                                                    <Button size='small' variant="outlined" color="error" startIcon={<CallEndIcon />} sx={{ mr: 3 }} onClick={hangupCall}>
                                                        Hangup
                                                    </Button>
                                                </Tooltip>
                                            }
                                        </Grid>
                                        {dataLoaded && showPhoneControls && !hasHungup &&
                                            <Grid item xs={12} md={12} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                                <PhoneControls IsInbound={true} />
                                            </Grid>
                                        }
                                        <Grid item xs={12} md={12} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            {dataLoaded &&
                                                <DoActivityOutcomes />
                                            }
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
    else {
        return <StandardSkeleton />
    }

}

export { DoActivityInboundPhoneCall }

export default DoActivityInboundPhoneCall;